import { TAB_TYPE } from '@repo/design-system/index'
import React, { useRef } from 'react'
import { ReflexContainer, ReflexElement, ReflexSplitter } from 'react-reflex'
import 'react-reflex/styles.css'
import { s_preparation } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../../../modules/ids/e2e/student'
import { TAB } from '../../../materials/const'
import { CONTENT_NAV_BAR_HEIGHT } from '../../../menu/ContentNavBar'
import { CONTENT_SUB_NAV_BAR_HEIGHT } from '../../../menu/ContentNavBarSub'
import FreeTalkingRightBody from './FreeTalkinngRightBody'
import LeftBody from './LeftBody'
import RightBody from './RightBody'
import SubTab from './SubTab'

interface TextbodyProps {
  lesson: any
  currentUser: any
  isReview: any
  currentTab: any
  setCurrentTab: any
  currentTabSub?: any
  setCurrentTabSub?: any
  ringleDocToken: any
  isEditable: any
  setIsEditable: any
  setTabData: any
  answer: any
  setAnswer: any
  lessonId?: any
  selectedShareState: any
  setSelectedShareState: any
  activeQuestionId: any
  setActiveQuestionId: any
  saveMoveSubTab: any
}

// 예습화면 네비게이션 아래 내용
export const Textbody = React.memo(
  ({
    lesson,
    currentUser,
    isReview,
    currentTab,
    setCurrentTab,
    currentTabSub,
    setCurrentTabSub,
    ringleDocToken,
    isEditable,
    setIsEditable,
    setTabData,
    answer,
    setAnswer,
    selectedShareState,
    setSelectedShareState,
    activeQuestionId,
    setActiveQuestionId,
    saveMoveSubTab,
  }: TextbodyProps) => {
    const iframeRef = useRef(null)
    const materialRef = useRef(null)
    const { t } = useTranslation()
    const handleResizeStart = () => {
      if (iframeRef.current) {
        iframeRef.current.style.pointerEvents = 'none'
      }
      if (materialRef.current) {
        materialRef.current.style.pointerEvents = 'none'
      }
    }

    const isFreeTalking = lesson?.course?.free_talking

    const MATERIAL_SUB_TABS = [
      // 인사이트 탭
      // (s)인사이트
      {
        dataRef: DATA_REF_KEY.btn_tab_insight,
        label: t(s_preparation.insight),
        key: TAB.INSIGHT,
      },
      // 자료 업로드 탭
      // ON 조건
      // - (s) 자유주제 수업일 때
      {
        label: t(s_preparation.document_submission),
        key: TAB.UPLOAD_FILE,
        none: !isFreeTalking,
      },
      // 링크 업로드 탭
      // ON 조건
      // - (t) 수업-링크 업로드 수업일때
      {
        label: t(s_preparation.btn_upload_link),
        key: TAB.UPLOAD_LINK,
        none: true,
      },
    ]

    const PRESTUDY_SUB_TABS = [
      {
        label: t(s_preparation.keyQuestion),
        key: TAB.QUESTION_SELECT,
        none: isFreeTalking,
      },
      {
        label: <div className="relative flex items-start">{t(s_preparation.googleDocs)}</div>,
        key: TAB.NOTE,
      },
    ]

    return (
      <>
        <ReflexContainer orientation="vertical">
          <ReflexElement minSize={250} className="left-pane no-scrollbar flex flex-col">
            <SubTab
              SUB_MENU_LIST={MATERIAL_SUB_TABS}
              activeTabIdx={currentTab}
              setActiveTabIdx={setCurrentTab}
              type={TAB_TYPE.SCROLL}
              lesson={lesson}
              currentUser={currentUser}
              isRightTab={false}
              saveMoveSubTab={saveMoveSubTab}
              isEditable={isEditable}
              setIsEditable={setIsEditable}
              answer={answer}
              activeQuestionId={activeQuestionId}
            />
            <LeftBody
              lesson={lesson}
              material={lesson?.course}
              expressions={lesson?.expressions}
              isReview={isReview}
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
              materialRef={materialRef}
              setTabData={setTabData}
            />
          </ReflexElement>
          <ReflexSplitter
            style={{
              height: `calc(100vh - ${CONTENT_NAV_BAR_HEIGHT + CONTENT_SUB_NAV_BAR_HEIGHT}px)`,
              position: 'relative',
              top: CONTENT_SUB_NAV_BAR_HEIGHT,
            }}
          />
          <ReflexElement minSize={250} className="right-pane no-scrollbar flex flex-col">
            {/* <StudentClassroomRightTabs data={lesson} ringleDocToken={ringleDocToken} /> */}
            <SubTab
              SUB_MENU_LIST={PRESTUDY_SUB_TABS}
              activeTabIdx={currentTabSub}
              setActiveTabIdx={setCurrentTabSub}
              type={TAB_TYPE.SCROLL}
              lesson={lesson}
              currentUser={currentUser}
              isRightTab={true}
              saveMoveSubTab={saveMoveSubTab}
              isEditable={isEditable}
              setIsEditable={setIsEditable}
              answer={answer}
              activeQuestionId={activeQuestionId}
            />
            {lesson?.course.free_talking ? (
              <FreeTalkingRightBody
                iframeRef={iframeRef}
                lesson={lesson}
                currentUser={currentUser}
                ringleDocToken={ringleDocToken}
              />
            ) : (
              <RightBody
                iframeRef={iframeRef}
                currentUser={currentUser}
                lesson={lesson}
                currentTabSub={currentTabSub}
                isEditable={isEditable}
                setIsEditable={setIsEditable}
                setTabData={setTabData}
                answer={answer}
                setAnswer={setAnswer}
                selectedShareState={selectedShareState}
                setSelectedShareState={setSelectedShareState}
                activeQuestionId={activeQuestionId}
                setActiveQuestionId={setActiveQuestionId}
                isReview={isReview}
              />
            )}
          </ReflexElement>
        </ReflexContainer>
      </>
    )
  }
)

Textbody.displayName = 'Textbody'

export default Textbody
